import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { AttributeTypeFacetModel } from "@insite/client-framework/Types/ApiModels";

const apiUri = "/api/v2/dana/searchVehicleFilter";
export interface SearchVehicleFilterApiParameter extends ApiParameter {
    year?: string,
    make?: string,
    model?: string,
    engine?: string,
    sortOrder?: string;
}
export interface SearchVehicleFilterResponse {
    filterFacets: AttributeTypeFacetModel[];
    filterFacet: AttributeTypeFacetModel;
}

export async function getVehicleFilterCollectionV2(parameter: SearchVehicleFilterApiParameter) {
    const filterModel = await get<SearchVehicleFilterResponse>(`${apiUri}`, parameter);
    const result = filterModel ?? undefined;
    return result;
}
